import cmmnRoutes from "@/router/items/common/cmmnRoutes";
import mainRoutes from "./MainRoutes";
import ecpRoutes from "./EcpRoutes";
import commuRoutes from "./CommuRouter";
import stdInfoRoutes from "./StdInfoRoute";
import inhaInfoRoutes from "../common/inhaInfoRoutes";

/**
 * meta: {
 *   requiresAuth: true  // 로그인 필요
 *   noCaching: true     // 캐싱 방지
 *   noCrumb: true       // 크럼브 네비게이션 미노출
 *   isDynamic: true     // 동적 라우트 (메뉴 권한 체크)
 *   menuCd: string      // 메뉴 코드
 *   title: string       // 국문 타이틀
 *   mobileHd: true      // 모바일 헤더 별도 적용
 *   likeBtn: true       // 모바일 헤더에 찜하기 버튼 노출
 *   site: 'inha'        // 영산대 페이지
 * }
 */

const staffRoutes = [
  {
    path: "",
    name: "index",
    redirect: { name: "staff" },
  },
  {
    path: "/",
    name: "staff",
    meta: {
      title: "교직원 화면",
      noCaching: true,
    },
    redirect: { name: "staffMain" },
    component: () => import("@/layout/LayoutMain.vue"),
    children: [
      ...mainRoutes, // 메인 라우트
      ...ecpRoutes, // 비교과 관리
      ...commuRoutes, // 커뮤니티 관리
      ...stdInfoRoutes, // 학생 정보 조회
      ...inhaInfoRoutes, // 영산대 사업소개 라우트
    ],
  },
  {
    path: "/login",
    meta: {
      isDynamic: false,
    },
    component: () => import("@/layout/LayoutSimple.vue"),
    children: [
      {
        path: "/onlyDainIndex",
        name: "onlyDainIndex",
        meta: { title: "교직원 로그인", isDynamic: false },
        component: () => import("@/views/common/login/CommonLogin.vue"),
      },
      {
        path: "/login",
        name: "staffLogin",
        meta: { title: "교직원 로그인", isDynamic: false },
        component: () => import("@/views/common/login/CommonLogin.vue"),
      },
    ],
  },
  {
    path: "/print-preview",
    meta: {
      auth: false,
      noCrumb: true,
    },
    component: () => import("@/components/base/PrintPreview.vue"),
  },
  ...cmmnRoutes, // 공통 라우트
];
export default staffRoutes;
